import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";

/**
 * Component to render Nominations Description of DTA on homepage
 */
const DTANominationsDescription = (): React.ReactElement => {
  return (
    <div
      className="flex flex-row items-center pl-1 text-center md:ml-18 md:px-0 lg:ml-5"
      data-testid="dta-nominations-description-component"
    >
      <IconFactory
        type={IconTypeEnum.apply}
        x={67}
        y={62}
        size={67}
        className="mr-2 w-3/12 md:ml-2 md:mr-3 lg:mr-4 lg:w-auto"
      />

      <div className="w-9/12 flex-col items-center justify-center text-center font-public-sans text-gray-850 md:mr-7 md:w-8/12 lg:w-auto">
        <h2 className="text-center align-middle font-poppins text-4xl font-medium md:text-6xl lg:text-8xl lg:leading-tight">
          Applications are now open.
        </h2>
      </div>
    </div>
  );
};

export default DTANominationsDescription;
